import { Checkbox, FormControlLabel, IconButton, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TablePaginationActions, TableRow, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from "react-router-dom";
import { TableHeader } from '../../../app/AppStyles';
import { SearchKeyFilter } from '../../../app/AppUtils';
import ContentLoader from '../../subcomponents/ContentLoader';
import FilterButton from '../../subcomponents/FilterButton';
import FilterSidebar from '../../subcomponents/FilterSidebar';
import PageLayout from '../../subcomponents/PageLayout';
import { fetchSearchStudents } from './searchStudentSlice';

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

export default function SearchStudentPage() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);
    const { searchStudents, searchStudentsStatus } = useSelector((state) => state.search.student);

    const [filter, setFilter] = useState("");
    const [isActive, setIsActive] = useState(true);

    useEffect(() => {
        dispatch(fetchSearchStudents(isActive));
    }, [dispatch, isActive]);

    const handleFilterResult = (item) => {
        return SearchKeyFilter(item, ["fullname", "studentNumber", "class", "email"], filter);
    }

    const NavigationFragment = () => {
        return (
            <ToggleButtonGroup
                color="primary"
                fullWidth
                exclusive
                value="STUDENTS"
                onChange={() => navigate('/zoeken/klas')}
            >
                <ToggleButton value="STUDENTS">{resourceFinal[appLanguage].words.STUDENTS}</ToggleButton>
                <ToggleButton value="CLASSES">{resourceFinal[appLanguage].words.CLASSES}</ToggleButton>
            </ToggleButtonGroup>
        );
    };

    const FilterFragment = () => {
        return (
            <FormControlLabel sx={{ alignSelf: 'center' }} control={<Checkbox checked={isActive} onChange={() => setIsActive(!isActive)} />} label={`${resourceFinal[appLanguage].words.ACTIVE}`} />
        );
    };

    const TableFragment = () => {
        const [page, setPage] = useState(0);
        const [rowsPerPage, setRowsPerPage] = useState(10);

        const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - searchStudents?.filter(handleFilterResult).length) : 0;

        const handleChangePage = (event, newPage) => {
            setPage(newPage);
        };

        const handleChangeRowsPerPage = (event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
        };

        return (
            <>
                <TableBody>
                    {(rowsPerPage > 0 ? searchStudents?.filter(handleFilterResult)?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : searchStudents?.filter(handleFilterResult))?.map(item =>
                        <TableRow key={item.studentId} sx={{ '&:nth-of-type(odd)': { bgcolor: 'white.main' }, height: 63 }}>
                            <TableCell align="center">
                                <Link to={`/zoeken/student/${item.studentId}`} style={{ color: 'black' }}>
                                    {item.studentNumber}
                                </Link>
                            </TableCell>
                            <TableCell align="left">{item.fullname}</TableCell>
                            <TableCell align="center">{item.class ?? "-"}</TableCell>
                            <TableCell align="left">{item.email}</TableCell>
                            <TableCell align="center">
                                <IconButton onClick={() => navigate(`/zoeken/student/${item.studentId}`)}>
                                    <ArrowForwardIosIcon color="secondary" />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    )}

                    {(rowsPerPage > 0 ? searchStudents?.filter(handleFilterResult)?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : searchStudents?.filter(handleFilterResult))?.length === 0 && <TableRow><TableCell colSpan={4}>{resourceFinal[appLanguage].messages.FILTER_RESULT_EMPTY}</TableCell></TableRow>}
                    {emptyRows > 0 && (
                        <TableRow style={{ height: 63 * emptyRows }}>
                            <TableCell colSpan={12} />
                        </TableRow>)}
                </TableBody>
                <TableFooter>
                    <TableRow>
                        <TablePagination
                            sx={{ border: 0 }}
                            rowsPerPageOptions={[10, 25, 50,
                                {
                                    label: searchStudents?.length < 100 ? resourceFinal[appLanguage].words.ALL : '100',
                                    value: searchStudents?.length < 100 ? -1 : 100
                                }
                            ]}
                            count={searchStudents?.filter(handleFilterResult)?.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                            labelDisplayedRows={({ from, to, count }) => { return `${from}-${to} ${resourceFinal[appLanguage].messages.OF_THE} ${count}`; }}
                            labelRowsPerPage={resourceFinal[appLanguage].messages.TABLE_ROWS_PER_PAGE}
                        />
                    </TableRow>
                </TableFooter>
            </>
        );
    };

    return (
        <PageLayout
            title={resourceFinal[appLanguage].words.STUDENT}
            titleLower={resourceFinal[appLanguage].words.SEARCH}
            content={
                <ContentLoader
                    successCondition={searchStudentsStatus === "success"}
                    errorCondition={searchStudentsStatus === "failed"}
                    content={
                        <TableContainer>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center" sx={{ ...TableHeader }}>{resourceFinal[appLanguage].words.NUMBER}</TableCell>
                                        <TableCell align="left" sx={{ ...TableHeader }}>{resourceFinal[appLanguage].words.NAME}</TableCell>
                                        <TableCell align="center" sx={{ ...TableHeader }}>{resourceFinal[appLanguage].words.CLASS}</TableCell>
                                        <TableCell align="left" sx={{ ...TableHeader }}>{resourceFinal[appLanguage].words.EMAIL}</TableCell>
                                        <TableCell align="center" padding="checkbox"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableFragment />
                            </Table>
                        </TableContainer>
                    }
                />
            } contentLeft={
                <FilterSidebar topContent={<NavigationFragment />} enableSearch searchFilter={filter} searchFilterSet={setFilter} filters={<FilterFragment />} />
            } contentBottom={
                <FilterButton filters={<FilterFragment />} />
            }
            bottomBar
            enableSearch
            searchFilter={filter}
            searchFilterSet={setFilter}
        />
    );
}
